import React, { useEffect } from 'react';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import { Button, Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Row, RowChild } from 'styles';
import { useUser } from 'hooks/use-user.hook';
import type { MappedContractSubscriberRequirement } from 'hooks/use-contract-requirements.hook';
import { ActionButton } from './contracts.style';

const getCopy = copyFor('settings.contractAgreements');

interface ContractProps {
  requirement: MappedContractSubscriberRequirement;
  disclosureContract?: MappedContractSubscriberRequirement;
  handleDisplayDisclosureModal?: () => void;
  isDisclosureState?: boolean;
}

export const IncompleteContract = ({
  requirement,
  disclosureContract,
  handleDisplayDisclosureModal,
  isDisclosureState,
}: ContractProps) => {
  const { data: user } = useUser();
  const ldClient = useLDClient();

  useEffect(() => {
    // @ts-expect-error Property 'kind' is missing
    // flag evaluates incorrectly if you add that -\_(o.o)_/-
    ldClient?.identify({
      key: user?.id?.toString(),
      custom: { state: requirement.stateAbbreviation?.toLowerCase() },
    });
  }, []);
  const { csEnablePersonalizedContracts } = useFlags();

  const fileUrl = requirement.contractVersionLanguage?.fileUrl
    ? requirement.contractVersionLanguage?.fileUrl
    : requirement.fileUrl;
  const id = requirement.contractVersionLanguage?.id
    ? requirement.contractVersionLanguage?.id
    : requirement.contractVersionId;

  const href = csEnablePersonalizedContracts
    ? routes({
        contractVersionId: requirement.contractVersionId,
        utilityAccountId: requirement.utilityAccountId,
      }).personalizedContract
    : fileUrl;

  return (
    <Row
      key={id}
      flex
      alignItems="center"
      hideTopBorder={true}
      hasBottomBorder={true}
    >
      <RowChild>
        <div>
          <Text tag="h2" textStyle="heading500">
            {requirement.displayName}
          </Text>
          <Text margin={{ top: '8px' }}>{getCopy('incomplete')}</Text>
        </div>
        {isDisclosureState &&
        disclosureContract &&
        disclosureContract?.contractVersionId ===
          requirement.contractVersionId ? (
          <Button
            onClick={handleDisplayDisclosureModal}
            size="small"
            backgroundless
          >
            Resend form
          </Button>
        ) : null}
        <ActionButton
          aria-label={getCopy('download', {
            agreementName: requirement.displayName,
          })}
          data-testid="view-contract-btn"
          icon="Eye"
          onClick={() => window.open(href, '_newtab')}
        />
      </RowChild>
    </Row>
  );
};
